
export default {
  name: 'Modal',
  props: {
    showModalPadding: {
      type: Boolean,
      default: true,
    },
  },
};
